import type { LoginFlow } from '@ory/client';
import { ROUTES } from '@constants';
import oryService from '../ory/ory.service';
import { getMfaPreference, type MfaPreferenceResponse } from './mfa-preference.service';

let aal2NavigationInProgress = false;

export const resetMfaLoginState = (): void => {
  aal2NavigationInProgress = false;
};

export const startAal2Flow = async (
  preference: MfaPreferenceResponse,
  returnTo: string
): Promise<LoginFlow | null> => {
  const expectedVia = preference.channel === 'sms' ? 'phone' : 'email';
  if (preference.oryVia !== expectedVia) throw new Error('Invalid MFA routing response');
  if (aal2NavigationInProgress) return null;
  aal2NavigationInProgress = true;
  try {
    // Never update or reuse the AAL1 password flow (or any earlier AAL2 flow). Ory creates a new
    // challenge whose courier is selected exclusively by the validated backend preference.
    const flow = await oryService.initializeLoginFlow(returnTo, 'aal2', preference.oryVia);
    const loginUrl = new URL(ROUTES.LOGIN, window.location.origin);
    loginUrl.searchParams.set('flow', flow.id);
    loginUrl.searchParams.set('return_to', returnTo);
    window.location.assign(loginUrl.toString());
    return flow;
  } catch (error) {
    aal2NavigationInProgress = false;
    throw error;
  }
};

/** Always refetch after AAL1; no identity-scoped preference is retained in the browser. */
export const startPreferredAal2Flow = async (returnTo: string): Promise<LoginFlow | null> =>
  startAal2Flow(await getMfaPreference(), returnTo);
